import React from 'react';

import { Typography } from '@mui/material';

import BackButton from '../../BackButton';
import { ContentCardPadding, ContentCardVariant, HeadingVariant } from '../types';

import { BackIconButton, Caption, StyledCardHeader, Title, TitleContainer } from './index.styles';

export interface ContentCardHeaderProps extends React.ComponentProps<typeof StyledCardHeader> {
  title?: string | React.ReactNode;
  titleVariant?: HeadingVariant;
  caption?: string | React.ReactNode;
  backButtonHref?: string;
  showDivider: boolean;
  padding: ContentCardPadding;
  variant: ContentCardVariant;
}

const ContentCardHeader = ({
  showDivider = true,
  title,
  titleVariant = 'h6',
  caption,
  backButtonHref,
  padding,
  variant,
  ...rest
}: ContentCardHeaderProps) => {
  const renderHeaderTitle = () => (
    <>
      <TitleContainer>
        <BackButton href={backButtonHref} button={BackIconButton} />
        {typeof title === 'string' ? <Title variant={titleVariant}>{title}</Title> : title}
      </TitleContainer>
      {caption &&
        (typeof caption === 'string' ? (
          <Caption>
            <Typography variant='caption'>{caption}</Typography>
          </Caption>
        ) : (
          caption
        ))}
    </>
  );
  return (
    <StyledCardHeader
      $showDivider={showDivider}
      title={renderHeaderTitle()}
      $padding={padding}
      $variant={variant}
      {...rest}
    />
  );
};

export default ContentCardHeader;
